module.exports = __webpack_public_path__ + "static/61a7950b796321f0ec57c5b94ed6fff90fc05bf0685c2f5d96f6d9f659b51117-d6ef52e2988d406f79091835c24debb8.png";